import { numberInputAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(numberInputAnatomy.keys);

const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle({
    // define the part you're going to style
    field: {
      borderRadius: getThemes(theme).radii.lg,
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.primary[80]}`,
      bg: 'white',
      _disabled: {
        wrap: {
          color: getThemes(theme).colors.palette.text.secondary[80],
        },
        backgroundColor: 'white',
        boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]}`,
        opacity: 1,
      },
    },
  });

export const datePickerTheme = (theme: ThemesKeys) => {
  return style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
  });
};

export default (theme: ThemesKeys) => datePickerTheme(theme);
